import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import VoucherLiabilityTable from './LiabilityTable'
import{Box} from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="View Liability"
                breadcrumb={["Dashboard", "Voucher", "Liability"]}
            />
                        <Box p={6}>

            <VoucherLiabilityTable />
            </Box>
        </div>
    )
}

export default Liability